// extracted by mini-css-extract-plugin
export default {"zoomControls":"fda-z","zoomControlButton":"gda-z","zoomBanner":"hda-z","bannerButton":"ida-z","imageButton":"jda-z","zoom":"kda-z","zoomContent":"lda-z"};